import { RolesAndOrganisationsResponse } from '../../api-models';
import { RolesAndOrganisations } from '../../types/core.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class GetRolesAndOrganisations extends BaseAdapter<RolesAndOrganisationsResponse> implements AdapterInterface {
  rawResponse: RolesAndOrganisationsResponse;

  async adaptResponse(): Promise<RolesAndOrganisations> {
    await this.fetchApiResponse('/api/roles-and-organisations', HTTPMethod.Get);
    return {
      roles: this.rawResponse.roles,
      organisations: this.rawResponse.organisations,
    };
  }
}
